import Model from '../Model'

export default class Creator extends Model {
    // Set the resource route of the model
    resource() {
        return 'admin/creators'
    }
}
